import { ZervantLocale } from '../enums/zervantLocale'
import { InvoiceLanguage } from '../types/invoiceLanguage'

export const invoiceLocaleToLanguage: Partial<Record<ZervantLocale, InvoiceLanguage>> = {
  [ZervantLocale.DE_DE]: 'de',
  [ZervantLocale.EN_GB]: 'en',
  [ZervantLocale.FI_FI]: 'fi',
  [ZervantLocale.FR_FR]: 'fr',
  [ZervantLocale.NL_NL]: 'nl',
  [ZervantLocale.SV_SE]: 'sv',
}
